"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hide_rgba;
/**
 * @name hide_rgba
 * @description make a given (scaled) rgba value transparent/invisble
 * @param {RGBA} rgba pixel
 * @returns a new rgba pixel with the same Red, Green and Blue values and a 0 alpha value
 */
function hide_rgba([r, g, b]) {
  return [r, g, b, 0];
}